// extracted by mini-css-extract-plugin
export default {"header":"feedHeader_header__RgWiV","greeting":"feedHeader_greeting__aRxcR","newSince":"feedHeader_newSince__qqSym","newCount":"feedHeader_newCount__D-bYa"};